import { render, staticRenderFns } from "./PageAccountMyAccount.vue?vue&type=template&id=6c2a540f&scoped=true&"
import script from "./PageAccountMyAccount.vue?vue&type=script&lang=js&"
export * from "./PageAccountMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./PageAccountMyAccount.vue?vue&type=style&index=0&id=6c2a540f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a540f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBreadcrumbs,VBtn,VCard,VCardTitle,VContainer})
